// src/services/api/endpoints/documents.ts
import { API_BASE_URL, fetchWithTokenRefresh } from '../client';

export type ElementType = 'Gatherings' | 'Spaces' | 'Users' | 'Communities';

export interface GenerateUploadRequest {
  file_name: string;
  file_extension: string; // e.g., 'jpg' | 'png'
  element: ElementType;    // use 'Gatherings' for gathering images
}

export interface GenerateUploadResponse {
  url: string;        // presigned PUT URL
  object_key: string; // S3 object key to save on the gathering
  mime_type: string;  // Content-Type to send on PUT
  element: ElementType;
}

/**
 * Requests a presigned S3 upload URL from the backend
 */
export const generateUploadUrl = async (
  token: string,
  payload: GenerateUploadRequest
): Promise<GenerateUploadResponse> => {
  const url = `${API_BASE_URL}/documents/generate-upload-url`;
  return await fetchWithTokenRefresh(
    url,
    token,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
};
